// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';           // optioneel: je globale CSS
import App from './App';
import reportWebVitals from './reportWebVitals';

// Zorg dat AuthProvider in src/AuthContext.js staat
import { AuthProvider } from './AuthContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* AuthProvider wikkelt de hele app, zodat useAuth() overal beschikbaar is */}
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>
);

reportWebVitals();
